module.exports = __webpack_public_path__ + "static/media/DER_Prévoyance_Individuelle_Dynamique.163dc1e5.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/common/documents/DER_Prévoyance_Individuelle_Dynamique.pdf
// module id = 185
// module chunks = 40